import { CustomWidgetCollection, JsonObject, Serializer } from 'survey-core';
var widget = {
  //the widget name. It should be unique and written in lowcase.
  name: 'rankingadvanced',
  //the widget title. It is how it will appear on the toolbox of the SurveyJS Editor/Builder
  title: 'Ranking (Image choices)',
  //the name of the icon on the toolbox
  iconName: 'icon-ranking',
  widgetIsLoaded: function() {
    return true; //we do not require anything so we just return true.
  },
  //SurveyJS library calls this function for every question to check, if it should use this widget instead of default rendering/behavior
  isFit: function(question) {
    //we return true if the type of question is rankingadvanced
    return question.getType() === 'rankingadvanced';
  },
  init() {
    Serializer.getProperty('imagePicker', 'showLabel').defaultValue = true;
    Serializer.getProperty('imagePicker', 'multiSelect').defaultValue = true;
    Serializer.findProperty('imagePicker', 'multiSelect').readOnly = true;
    Serializer.getProperty('imagePicker', 'description').defaultValue =
      'Note: Please click/tap the option in the order of your preference.Click/tap any option again to clear its rank.';
  },
  activatedByChanged: function(activatedBy) {
    JsonObject.metaData.addClass('rankingadvanced', [], null, 'imagePicker');
  },
  //If you want to use the default question rendering then set this property to true. We do not need any default rendering, we will use our our htmlTemplate
  isDefaultRender: true,
  //The main function, rendering and two-way binding
  afterRender: function(question, el) {
    el.setAttribute('class', 'rankingadvanced sd-question__content');
    el.getElementsByTagName('fieldset')[0].setAttribute(
      'class',
      'sd-selectbase sd-imagepicker'
    );
    question.value =
      question.value && question.value.length > 0 ? question.value : [];
    var elements = el.getElementsByTagName('fieldset')[0].children;
    if (elements.length > 1) {
      for (let i = 0, l = elements.length; i < l; ++i) {
        var child = elements[i];
        if (child.nodeType === 1 && child.tagName === 'DIV') {
          child.setAttribute('class', 'sd-imagepicker__item');
          child.getElementsByTagName('input')[0].disabled = true;
          child
            .getElementsByTagName('input')[0]
            .setAttribute('class', 'sd-imagepicker__control sd-visuallyhidden');
          var imagePickerlabel = child.getElementsByTagName('label')[0];
          imagePickerlabel
            .getElementsByTagName('div')[0]
            .setAttribute('class', 'sd-imagepicker__item-decorator');
          var imagecontainerdiv = imagePickerlabel.getElementsByTagName(
            'div'
          )[1];
          imagecontainerdiv.setAttribute(
            'class',
            'sd-imagepicker__image-container'
          );
          imagePickerlabel.setAttribute('class', 'sd-imagepicker__label');
          var lb = document.createElement('span');
          lb.setAttribute(
            'class',
            'rankLabel sd-imagepicker__customrank-decorator'
          );
          lb.innerText = '';
          // lb.innerText =
          //   rankArray.indexOf(i) > -1 ? rankArray.indexOf(i) + 1 : '';
          imagecontainerdiv.appendChild(lb);
          var onbuttonClick = function() {
            var valueArray = [];
            if (question.value) {
              for (let index = 0; index < question.value.length; index++) {
                valueArray.push(
                  question.choices.findIndex(
                    x => x.value === question.value[index]
                  ) + 1
                );
              }
            }
            const idx = valueArray.indexOf(i);
            if (idx > -1) {
              valueArray.splice(idx, idx !== -1 ? 1 : 0);
              for (
                let lbIndex = 0, lbls = elements.length;
                lbIndex < lbls;
                ++lbIndex
              ) {
                var eleRankLabel = elements[lbIndex].querySelector(
                  '.rankLabel'
                );
                if (eleRankLabel) {
                  eleRankLabel.innerText =
                    valueArray.indexOf(lbIndex) > -1
                      ? valueArray.indexOf(lbIndex) + 1
                      : '';
                }
              }
            } else {
              valueArray.push(i);
            }
            var ranklabel = this.getElementsByClassName('rankLabel')[0];
            ranklabel.innerText =
              valueArray.indexOf(i) > -1 ? valueArray.indexOf(i) + 1 : '';
            question.value = [];
            var questionValue = [];
            for (let j = 0; j < valueArray.length; j++) {
              questionValue.push(question.choices[valueArray[j] - 1].value);
            }
            question.value = questionValue;
          };
          child.onclick = onbuttonClick;
        }
      }
    }

    var onValueChangedCallback = function() {
      var rankArray = [];
      //const question = this.question;
      if (question.value) {
        for (let index = 0; index < question.value.length; index++) {
          var choiceindex =
            question.choices.findIndex(x => x.value === question.value[index]) +
            1;
          rankArray.push(choiceindex);
          // question.value = rankArray;
          console.log('questionValue', question.value);
          // elements.querySelector('ranklabel')[index].innerText = choiceindex;
        }
      }
    };
    //if the question value changed in the code, for example you have changed it in JavaScript
    question.valueChangedCallback = onValueChangedCallback;
    //set initial value
    onValueChangedCallback();
  }
};
//Register our widget in singleton custom widget collection
CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
